import { useEffect } from 'react';
import { publicConfigResponseSchema } from '@unit/shared';
import i18n from './index.js';
import { publicGet } from '../lib/api.js';

/**
 * Switches the app to the company-wide language (owner, 2026-09-19, story
 * 38). Called once at the root, before sign-in, so the sign-in screen is in
 * the chosen language too. A failed fetch leaves Hebrew in place — the
 * default — rather than blocking anything.
 */
export function useAppLanguage(): void {
  useEffect(() => {
    let cancelled = false;
    void publicGet('/public/config', publicConfigResponseSchema)
      .then((config) => {
        if (!cancelled && i18n.resolvedLanguage !== config.language) void i18n.changeLanguage(config.language);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, []);
}
